module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-about-meet-dr__container"
  }, [_c('div', {
    staticClass: "custom-about-meet-dr__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-about-meet-dr__content-container"
  }, [_c('div', {
    staticClass: "custom-about-meet-dr__top",
    domProps: {
      "innerHTML": _vm._s(_vm.props.top_row)
    }
  }), _c('div', {
    staticClass: "custom-about-meet-dr__bottom"
  }, [_c('div', {
    staticClass: "custom-about-meet-dr__left"
  }, [_c('div', {
    staticClass: "custom-about-meet-dr__content"
  }, [_c('div', {
    staticClass: "custom-about-meet-dr__education"
  }, [_c('h3', [_vm._v(_vm._s(_vm.props.education.title))]), _vm._l((_vm.props.education.schools), function(school, i) {
    return _c('div', {
      staticClass: "custom-about-meet-dr__schools",
      domProps: {
        "innerHTML": _vm._s(school.text)
      }
    })
  })], 2), _c('div', {
    staticClass: "custom-about-meet-dr__outside",
    domProps: {
      "innerHTML": _vm._s(_vm.props.outside)
    }
  })])]), _c('div', {
    staticClass: "custom-about-meet-dr__right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hovered),
      expression: "!hovered"
    }],
    staticClass: "custom-about-meet-dr__img",
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.img
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hovered),
      expression: "hovered"
    }],
    staticClass: "custom-about-meet-dr__img",
    on: {
      "mouseleave": function($event) {
        _vm.hovered = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.img_silly
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e366378","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-meet-dr/custom-about-meet-dr.pug
// module id = 578
// module chunks = 1